


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Token } from '@/presenters/TokenDeclaration';
import { groupByTokenName } from './groupByTokenName';
import EmptyTokens from './EmptyTokens.vue';
import Table from '@/ui/Table/Table.vue';
import * as presenters from '@/presenters/';

@Component({
  components: {
    EmptyTokens,
    Table,
    ...presenters,
  },
})
export default class TokensSummary extends Vue {
  @Prop({ required: true }) private readonly tokens!: Token[];

  mounted(): void | never {
    if (!Array.isArray(this.tokens)) {
      throw new Error(`Tokens should be array, received ${typeof this.tokens}`);
    }
  }

  get groupedTokens(): [string, Token[]][] {
    const group = groupByTokenName(this.tokens);

    return Object.entries(group);
  }

  existComponentType({ token = 'unknown' }: Token): boolean | never {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const Component = presenters[token];

    if (!Component) {
      throw new Error(`Presenter '${token}' does not exist`);
    }

    return true;
  }
}
